import type { Validator } from './types';

export function makeIntegerValidator<TValue>(
    message: string = 'Необходимо ввести целое число',
): Validator<TValue> {
    return (value: unknown) => (Number.isNaN(value) || Number(value) % 1 > 0 ? message : undefined);
}
